export const websiteName = "Jakub Staniszewski";
export const domain = "jakub.studio";
export const emailDomain = domain;
export const githubRepo = "jakub-studio/website";
export const defaultThemeColour = "#FFA50A";
export const websiteLocale = "en-GB"; // Used in https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleDateString

// Used in footer and <head/> elements.
export const socialHandles = {
	instagram: "jakub.studio",
	twitter: "jakubstudio_",
	linkedin: "jakub-staniszewski",
	vimeo: "jakubstudio"
};

// runs document.designMode = "on" when isDev (defined below) is true.
export const useDocumentDesignModeDuringDev = false;

export const recordSourceQueryMiddleware: boolean = true;
